export default {
    POT_HeaderQuestion : 0,
    POT_TrackQuestion : 1,
    POT_TrackAuto:2,
    POT_TrackCTag:3,
    POT_Script:4, 
    POT_CFAuto:5
}
// This type is also in CentralAPI, keep consistent if you modify it